<template>
  <div id="searchBox">
    <div class="box news-box" style="background:#FAFAFA;padding: 20px 80px;">
      <el-form class="searchBox" :inline="true">
        <el-form-item label style="width:80%" class="searchContent">
          <el-input placeholder="请输入要搜索的内容" v-model="query.content" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label>
          <el-button type="warning" @click="handelNormalSearch()">检索</el-button>
          <el-button type="primary" plain @click="dialogFormVisible = true">高级检索</el-button>
        </el-form-item>
      </el-form>
      <div class="recomomed">
        <ul>
          <li>
            <span>推荐关键词：</span>
          </li>
          <li v-for="(item,index) in recomomedList" :key="index">
            <a @click="handelFastSearch(item)">{{item}}</a>
          </li>
        </ul>
      </div>
      <div class="clear"></div>
      <div class="searchResultBox" v-if="tableData && tableData.length>0">
        <ul>
          <li v-for="(item,index) in tableData" :key="index" @click="handelDetail(item)">
            <div>
              <div class="title">
                <div class="t-title">{{item.title}}</div>
                <div class="r-title">{{item.textType | typeFormat}}</div>
              </div>
              <div class="clear"></div>
              <div class="t-content">{{item.textContent | getSimpleText}}</div>
              <div class="t-footer">
                <div class="l-link"></div>
                <div class="r-time">{{item.createTime | dateFormat}}</div>
              </div>
              <div class="clear"></div>
            </div>
          </li>
        </ul>
      </div>
      <div v-else class="noMessage">
        抱歉，没有找到与“
        <span style="color:red">{{query.content}}</span> ”相关的内容。
        <div style="margin-top:30px">
          <p>建议：</p>
          <p>检查输入是否正确</p>
          <p>简化输入词</p>
          <p>尝试其他相关词，如同义、近义词等.</p>
        </div>
      </div>
      <div class="page" v-if="tableData && tableData.length>0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="query.current"
          :page-sizes="[5,10, 20, 50, 100,500]"
          :page-size="query.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="query.total"
          background
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="高级搜索" :visible.sync="dialogFormVisible" width="475px">
      <el-form :model="query">
        <el-form-item label="搜索关键词" :label-width="formLabelWidth">
          <el-input autocomplete="off" size="samll" v-model="query.content"></el-input>
        </el-form-item>
        <el-form-item label="检索字段" :label-width="formLabelWidth">
          <el-radio-group v-model="query.type">
            <el-radio :label="0">全部</el-radio>
            <el-radio :label="1">标题</el-radio>
            <el-radio :label="2">正文</el-radio>
            <el-radio :label="3">作者</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="每页显示" :label-width="formLabelWidth">
              <el-select placeholder v-model="query.size">
                <el-option label="10条" :value="10"></el-option>
                <el-option label="20条" :value="20"></el-option>
                <el-option label="50条" :value="50"></el-option>
                <el-option label="100条" :value="100"></el-option>
                <el-option label="500条" :value="500"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="排序字段" :label-width="formLabelWidth">
              <el-select placeholder size="samll" v-model="query.sortColumn">
                <el-option label="日期" value="CREATE_TIME"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label label-width="30px">
              <el-radio-group v-model="query.sortType">
                <el-radio label="DESC">降序</el-radio>
                <el-radio label="ASC">升序</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="日期范围" :label-width="formLabelWidth">
          <el-date-picker
            v-model="query.timeRange"
            value-format="yyyy-MM-dd hh:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button type="primary" @click="handelSeniorSearch">搜索</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getSearchPage } from "../../api/index";
export default {
  name: "",
  data() {
    return {
      value1: "",
      dialogFormVisible: false,
      formLabelWidth: "100px",
      query: {
        timeRange: "",
        total: 0,
        current: 1,
        size: 10,
        type: 0,
        content: null,
        sortColumn: "CREATE_TIME",
        sortType: "DESC",
        startDate: null,
        endDate: null
      },
      recomomedList: [
        "水土保持方案",
        "水保",
        "验收",
        "方案",
        "水土保持补偿费",
        "资质",
        "水土保持法",
        "公报",
        "生态文明工程"
      ],
      tableData: []
    };
  },
  created() {
    this.query.content = this.$route.query.searchContent;
    this.handelSearch();
  },
  filters: {
     getSimpleText:function(html){
       if(!html){
         return ""
       }
        html = html.replace(/(\n)/g, "—"); 
        html = html.replace(/(\n)/g, "");    
        html = html.replace(/(\t)/g, "");    
        html = html.replace(/(\r)/g, "");    
        html = html.replace(/<\/?[^>]*>/g, "");    
        html = html.replace(/\s*/g, "");  
        html = html.replace(/&nbsp;/g, ""); 
        html = html.replace(/&ldquo;/g, "\"")
        html = html.replace(/&rdquo;/g, "\"")
        return html;
      },
    //将时间戳过滤为正常日期格式
			dateFormat: function (data) {
        if(!data){
          return;
        }
			  var date = new Date(data.replace(/-/g,"/")).Format("yyyy-MM-dd");
			  return date;
			},
    typeFormat: function(data) {
      if (data == 1) {
        return "水保新闻";
      }
      if (data == 2) {
        return "公告栏";
      }
      if (data == 3) {
        return "综合治理";
      }
      if (data == 4) {
        return "监督管理";
      }
      if (data == 5) {
        return "监测管理";
      }
      if (data == 6) {
        return "政策法规";
      }
      if (data == 7) {
        return "植物资源";
      }
      if (data == 8) {
        return "灾害预案";
      }
      if (data == 9) {
        return "科研成果";
      }
      if (data == 10) {
        return "相关会议";
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$set(this.query, "size", val);
      this.handelSearch();
    },
    handleCurrentChange(val) {
      this.$set(this.query, "current", val);
      this.handelSearch();
    },
    handelDetail(item) {
      if (item.textType == 1) {
        this.$router.push({
          path: "/newDetail/" + item.id
        });
      }
      if (item.textType == 2) {
        this.$router.push({
          path: "/noticeDetail/" + item.id
        });
      }
      if (item.textType == 3) {
        this.$router.push({
          path: "/comprehensiveControlDetail/" + item.id
        });
      }
      if (item.textType == 4) {
        this.$router.push({
          path: "/supervisionDetail/" + item.id
        });
      }
      if (item.textType == 5) {
        this.$router.push({
          path: "/monitoringDetail/" + item.id
        });
      }
      if (item.textType == 6) {
        this.$router.push({
          path: "/policiesAndRegulationsDetail/" + item.id
        });
      }
      if (item.textType == 7) {
        this.$router.push({
          path: "/popularScienceKnowledgeDetail/" + row.id,
          query: {
            openId: 1
          }
        });
      }
      if (item.textType == 8) {
        this.$router.push({
          path: "/popularScienceKnowledgeDetail/" + row.id,
          query: {
            openId: 2
          }
        });
      }
      if (item.textType == 9) {
        this.$router.push({
          path: "/popularScienceKnowledgeDetail/" + row.id,
          query: {
            openId: 3
          }
        });
      }
      if (item.textType == 10) {
        this.$router.push({
          path: "/popularScienceKnowledgeDetail/" + row.id,
          query: {
            openId: 4
          }
        });
      }
    },
    handelSearch() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        fullscreen: false,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      getSearchPage(this.query).then(res => {
        loading.close();
        this.tableData = res.data.records;
        this.query.total = res.data.total || 0;
      });
    },
    handelNormalSearch() {
      this.query.current = 1;
      this.query.size = 10;
      this.query.type = 0;
      this.query.sortColumn = "CREATE_TIME";
      this.query.sortType = null;
      this.query.startDate = null;
      this.query.endDate = null;
      this.handelSearch();
    },
    handelFastSearch(item) {
      this.query.content = item;
      this.handelSearch();
    },
    handelSeniorSearch() {
      this.query.startDate = this.query.timeRange[0];
      this.query.endDate = this.query.timeRange[1];
      this.handelSearch();
      this.dialogFormVisible = false;
    }
  }
};
</script>
<style lang="css">
.recomomed ul li {
  float: left;
}
.recomomed ul li span {
  padding: 5px 0px;
  border: 1px solid transparent;
}

.recomomed ul li a {
  display: inline-block;
  padding: 5px 15px;
  background: #f3f3f3;
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  margin-right: 10px;
  cursor: pointer;
}
.searchResultBox {
  margin-top: 50px;
}
.searchResultBox ul li {
  background: #fff;
  padding: 20px 20px;
  border-radius: 6px;
  -webkit-box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.075),
    0px 0px 8px rgba(230, 235, 240, 0.6);
  box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.075),
    0px 0px 8px rgba(230, 235, 240, 0.6);
  margin-bottom: 20px;
}
.searchResultBox ul li .title .t-title {
  float: left;
  font-size: 19px;
  margin-bottom: 20px;
  width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #444444;
}
.searchResultBox ul li .title .r-title {
  float: right;
  color: #ffcb5a;
}
.searchResultBox ul li .t-content {
  color: #6c6c6c;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  margin-bottom: 20px;
}
.searchResultBox ul li .t-content img {
  width: 100px;
  height: 100px;
}
.searchResultBox ul li .t-footer .l-link {
  float: left;
  width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.searchResultBox ul li .t-footer .l-link a {
  color: #47c4e2;
}
.searchResultBox ul li .t-footer .r-time {
  float: right;
  color: #bebebe;
}
.noMessage {
  font-size: 14px;
  margin-top: 15px;
  color: #272727;
}
</style>
<style lang="" >
#searchBox .searchContent .el-form-item__content {
  width: 100%;
}
#searchBox .el-input__inner {
  -webkit-box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.075),
    0px 0px 8px rgba(230, 235, 240, 0.6);
  box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.075),
    0px 0px 8px rgba(230, 235, 240, 0.6);
}
#searchBox .el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 340px;
}
#searchBox .dialog-footer .el-button--primary {
  background-color: rgba(1, 173, 214, 1);
  border-color: rgba(1, 173, 214, 1);
}
</style>


// WEBPACK FOOTER //
// src/views/search/index.vue